import React, { useState } from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { getUrl } from "aws-amplify/storage";

export const UserCard = ({ combinedName, email, phone, photoUrl }) => {
    const [s3Link, setS3Link] = useState("");
    useEffect(() => {
        const getS3Url = async () => {
            if (photoUrl) {
                const data = await getUrl({ key: photoUrl });
                setS3Link(data?.url);
            }
        };
        getS3Url();
    }, [photoUrl]);
    const doNothing = (event) => {
        // Prevent opening the user modal
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <Box
            // TODO: move styles to the theme
            sx={{
                minWidth: "350px",
                display: "flex",
                gap: "1.2rem",
                alignItems: "center"
            }}
        >
            <Avatar
                variant="rounded"
                src={s3Link}
                sx={{
                    width: 50,
                    height: 50,
                    borderRadius: "50%"
                }}
                alt="User"
            />
            <Stack>
                <Typography
                    sx={{
                        fontWeight: 500,
                        cursor: "pointer",
                        color: "black",
                        lineHeight: "21px"
                    }}
                    variant="body1"
                >
                    {combinedName}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ cursor: "default" }}
                    onClick={doNothing}
                >
                    {email}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ cursor: "default" }}
                    onClick={doNothing}
                >
                    {phone}
                </Typography>
            </Stack>
        </Box>
    );
};
